module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-flex-content"
  }, _vm._l((this.content), function(slice) {
    return _c('div', {
      staticClass: "c-flex-content__slice-container"
    }, [(slice.type === 'text') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(slice.value)
      }
    })]) : _vm._e(), _vm._v(" "), (slice.type === 'html_snippet') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('div', {
      directives: [{
        name: "append",
        rawName: "v-append",
        value: (slice.code),
        expression: "slice.code"
      }],
      class: slice.isFacebookVideo ? 'c-flex-content__html-snippet is-facebook' : 'c-flex-content__html-snippet'
    })]) : _vm._e(), _vm._v(" "), (slice.type === 'images') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, _vm._l((slice.images), function(image) {
      return _c('figure', {
        class: 'c-flex-content__image-wrapper c-flex-content__image-wrapper--' + image.imageSize
      }, [_c('img', {
        class: 'c-flex-content__image c-flex-content__image--' + image.imageSize,
        attrs: {
          "src": image.imageUrl,
          "alt": image.imageAltText
        }
      }), _vm._v(" "), (image.caption) ? _c('figcaption', {
        domProps: {
          "innerHTML": _vm._s(image.caption)
        }
      }) : _vm._e()])
    })) : _vm._e(), _vm._v(" "), (slice.type === 'oembed') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('c-oembed', {
      attrs: {
        "oembedData": slice.oembedData
      }
    })], 1) : _vm._e(), _vm._v(" "), (slice.type === 'teaser_block') ? _c('div', {
      class: 'c-flex-content__slice c-flex-content__slice--' + slice.type
    }, [_c('c-teaser-block', {
      attrs: {
        "teaserData": slice.teaserData
      }
    })], 1) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fe83151"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlexContent.vue
// module id = 254
// module chunks = 0